
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class AppBtnToolheadMove extends Vue {
  @Prop({ type: String, required: true })
  public icon!: string

  @Prop()
  public disabled!: boolean

  @Prop({ type: String, default: 'btncolor' })
  public color!: string

  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ type: String, default: '' })
  public badge!: string

  @Prop({ type: String, default: '' })
  public tooltip!: string

  @Prop({ type: Boolean, default: false })
  public smallIcon!: boolean

  get hasDefaultSlot () {
    return !!this.$slots.default || !!this.$scopedSlots.default
  }
}
